import React from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { AcmeWide } from "../components/typography";

const Wrapper = styled.div`
  background: ${(props) => (props.dark ? Colors.sage : Colors.cream3)};

  padding: 64px 32px;

  > div {
    margin-bottom: 40px;
  }

  @media ${Breakpoints.tablet} {
    padding: 160px 32px;
  }

  & > div span {
    color: ${(props) => (props.dark ? Colors.cream2 : Colors.grey)};
  }
`;

const Text = styled.p`
  font-family: ${AcmeWide};
  font-weight: 300;

  max-width: 1080px;
  margin: 0 auto;

  font-size: 24px;
  line-height: 32px;

  text-align: center;

  color: ${(props) => (props.dark ? Colors.cream2 : Colors.hunter)};;

  @media ${Breakpoints.tablet} {
    font-size: 40px;
    line-height: 48px;
  }

  p {
    font-family: ${AcmeWide};
    font-weight: 300;

    max-width: 1080px;
    margin: 0 auto;

    font-size: 24px;
    line-height: 32px;

    text-align: center;

    color: ${(props) => (props.dark ? Colors.cream2 : Colors.hunter)};;

    @media ${Breakpoints.tablet} {
      font-size: 40px;
      line-height: 48px;
    }
  }
`;

export default function Statement({ header, text, dark = false }) {
  return (
    <Wrapper dark={dark}>
      {header && <DomeHeader text={header} centered />}
      <Text dark={dark}>{text}</Text>
    </Wrapper>
  );
}
